import { variantShadow } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import styled, { CSSProperties } from 'styled-components';

interface VariantDateProps {
    date: Date;
    style?: CSSProperties;
    className?: string;
}

export const VariantDate = (props: VariantDateProps) => {
    const month = props.date.toLocaleString('en-US', { month: 'short' });
    const day = props.date.getDate();

    return (
        <S_VariantDate className={props.className} style={props.style}>
            <S_Month>{month.toUpperCase()}</S_Month>
            <S_Date>{day}</S_Date>
        </S_VariantDate>
    );
};

const S_VariantDate = styled.div`
    width: 35px;
    height: 35px;
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: ${variantShadow};
`;

const S_Month = styled.div`
    height: 13px;
    width: 100%;
    background: linear-gradient(180deg, #e14541 0%, #aa2b27 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    font-family: ${({ theme }) => theme.fonts.medium};
    color: white;
`;

const S_Date = styled.div`
    height: 22px;
    width: 100%;
    background: linear-gradient(180deg, #ffffff 0%, #efefef 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: ${({ theme }) => theme.fonts.semiBold};
    color: ${({ theme }) => theme.colors.black};
    padding: 0 0 2px 0;
`;
